import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { AI_CONTENT_CATCHUP_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys';

export const AI_CONTENT_CATCHUP_INTERACTION_METRIC = createInteractionMetric({
	key: AI_CONTENT_CATCHUP_INTERACTION,
});
